import axios, { AxiosInstance, CancelToken, AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { PaymentTypeDTO, ShoppingCartDTO, ShoppingCartInternalItemDTO, ShoppingCartItemDTO } from "./ShoppingCartClientDTO";
import { BaseNomDTO } from "../ClientDTO";

export class ShoppingCartClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();
        this.instance.interceptors.request.use(
          config => {
              const token = localStorage.getItem('accessToken');
              if (token) {
                  if (!config.headers) {
                      config.headers = {};
                  }
                  config.headers['Authorization'] = `Bearer ${token}`;
              }
              return config;
          },
          error => {
              return Promise.reject(error);
          }
      );
        this.baseUrl = baseUrl ?? "";
  
    }

    
    /**
     * @param body (optional) 
     * @return OK
     */
    deleteshoppingcartitem(body?: ShoppingCartInternalItemDTO | undefined, cancelToken?: CancelToken): Promise<boolean> {
      let url_ = this.baseUrl + "/api/shoppingcart/deleteshoppingcartitem";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(body);

      let options_: AxiosRequestConfig = {
          data: content_,
          method: "DELETE",
          url: url_,
          headers: {
              "Content-Type": "application/json",
              "Accept": "text/plain"
          },
          cancelToken
      };

      return this.instance.request(options_).catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
              return _error.response;
          } else {
              throw _error;
          }
      }).then((_response: AxiosResponse) => {
          return this.processDeleteshoppingcartitem(_response);
      });
  }

  protected processDeleteshoppingcartitem(response: AxiosResponse): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && typeof response.headers === "object") {
          for (const k in response.headers) {
              if (response.headers.hasOwnProperty(k)) {
                  _headers[k] = response.headers[k];
              }
          }
      }
      if (status === 200) {
          const _responseText = response.data;
          let result200: any = null;
          let resultData200  = _responseText;
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return Promise.resolve<boolean>(result200);

      } else if (status !== 200 && status !== 204) {
          const _responseText = response.data;
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Promise.resolve<boolean>(null as any);
  }

    /**
     * @param shoppingCartIdentity (optional) 
     * @return OK
     */
    paymenttypes( cancelToken?: CancelToken): Promise<PaymentTypeDTO[]> {
        let url_ = this.baseUrl + "/api/shoppingcart/paymenttypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaymenttypes(_response);
        });
    }

    protected processPaymenttypes(response: AxiosResponse): Promise<PaymentTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PaymentTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentTypeDTO[]>(null as any);
    }

       updatestatus(shoppingCartItemId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
            let url_ = this.baseUrl + "/api/shoppingcart/updatestatus?";
            if (shoppingCartItemId === null)
                throw new Error("The parameter 'shoppingCartItemId' cannot be null.");
            else if (shoppingCartItemId !== undefined)
                url_ += "ShoppingCartItemId=" + encodeURIComponent("" + shoppingCartItemId) + "&";
            url_ = url_.replace(/[?&]$/, "");
    
            let options_: AxiosRequestConfig = {
                method: "POST",
                url: url_,
                headers: {
                },
                cancelToken
            };
    
            return this.instance.request(options_).catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            }).then((_response: AxiosResponse) => {
                return this.processUpdatestatus(_response);
            });
        }
    
        protected processUpdatestatus(response: AxiosResponse): Promise<void> {
            const status = response.status;
            let _headers: any = {};
            if (response.headers && typeof response.headers === "object") {
                for (const k in response.headers) {
                    if (response.headers.hasOwnProperty(k)) {
                        _headers[k] = response.headers[k];
                    }
                }
            }
            if (status === 200) {
                const _responseText = response.data;
                return Promise.resolve<void>(null as any);
    
            } else if (status !== 200 && status !== 204) {
                const _responseText = response.data;
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }
            return Promise.resolve<void>(null as any);
        }
    
    /**
     * @param shoppingCartIdentity (optional) 
     * @return OK
     */
    pay(shoppingCartIdentity?: string | undefined, cancelToken?: CancelToken): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/api/shoppingcart/pay?";
        if (shoppingCartIdentity === null)
            throw new Error("The parameter 'shoppingCartIdentity' cannot be null.");
        else if (shoppingCartIdentity !== undefined)
            url_ += "shoppingCartIdentity=" + encodeURIComponent("" + shoppingCartIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPay(_response);
        });
    }

    protected processPay(response: AxiosResponse): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShoppingCartDTO.fromJS(resultData200);
            return Promise.resolve<ShoppingCartDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartDTO>(null as any);
    }
    
    
        /**
         * @param identity (optional) 
         * @return OK
         */
        cancel(identity?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
            let url_ = this.baseUrl + "/api/shoppingcart/cancel?";
            if (identity === null)
                throw new Error("The parameter 'identity' cannot be null.");
            else if (identity !== undefined)
                url_ += "identity=" + encodeURIComponent("" + identity) + "&";
            url_ = url_.replace(/[?&]$/, "");
    
            let options_: AxiosRequestConfig = {
                method: "DELETE",
                url: url_,
                headers: {
                    "Accept": "text/plain"
                },
                cancelToken
            };
    
            return this.instance.request(options_).catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            }).then((_response: AxiosResponse) => {
                return this.processCancel(_response);
            });
        }
    
        protected processCancel(response: AxiosResponse): Promise<boolean> {
            const status = response.status;
            let _headers: any = {};
            if (response.headers && typeof response.headers === "object") {
                for (const k in response.headers) {
                    if (response.headers.hasOwnProperty(k)) {
                        _headers[k] = response.headers[k];
                    }
                }
            }
            if (status === 200) {
                const _responseText = response.data;
                let result200: any = null;
                let resultData200  = _responseText;
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
        
                return Promise.resolve<boolean>(result200);
    
            } else if (status !== 200 && status !== 204) {
                const _responseText = response.data;
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }
            return Promise.resolve<boolean>(null as any);
        }

        
    /**
     * @return OK
     */
    getlatestpendingcart( cancelToken?: CancelToken): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/api/shoppingcart/getlatestpendingcart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetlatestpendingcart(_response);
        });
    }

    protected processGetlatestpendingcart(response: AxiosResponse): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShoppingCartDTO.fromJS(resultData200);
            return Promise.resolve<ShoppingCartDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartDTO>(null as any);
    }

    /**
     * @param shoppingCartIdentity (optional) 
     * @return OK
     */
    shoppingcartitemsbyidentitycount(shoppingCartIdentity?: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/shoppingcart/shoppingcartitemsbyidentitycount?";
        if (shoppingCartIdentity === null)
            throw new Error("The parameter 'shoppingCartIdentity' cannot be null.");
        else if (shoppingCartIdentity !== undefined)
            url_ += "shoppingCartIdentity=" + encodeURIComponent("" + shoppingCartIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShoppingcartitemsbyidentitycount(_response);
        });
    }

    protected processShoppingcartitemsbyidentitycount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

   getlatestcart( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/shoppingcart/getlatestcart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetlatestcart(_response);
        });
    }

    protected processGetlatestcart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
     addpatient(body?: ShoppingCartDTO | undefined, cancelToken?: CancelToken): Promise<ShoppingCartDTO> {
            let url_ = this.baseUrl + "/api/shoppingcart/addpatient";
            url_ = url_.replace(/[?&]$/, "");
    
            const content_ = JSON.stringify(body);
    
            let options_: AxiosRequestConfig = {
                data: content_,
                method: "POST",
                url: url_,
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "text/plain"
                },
                cancelToken
            };
    
            return this.instance.request(options_).catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            }).then((_response: AxiosResponse) => {
                return this.processAddpatient(_response);
            });
        }
    
        protected processAddpatient(response: AxiosResponse): Promise<ShoppingCartDTO> {
            const status = response.status;
            let _headers: any = {};
            if (response.headers && typeof response.headers === "object") {
                for (const k in response.headers) {
                    if (response.headers.hasOwnProperty(k)) {
                        _headers[k] = response.headers[k];
                    }
                }
            }
            if (status === 200) {
                const _responseText = response.data;
                let result200: any = null;
                let resultData200  = _responseText;
                result200 = ShoppingCartDTO.fromJS(resultData200);
                return Promise.resolve<ShoppingCartDTO>(result200);
    
            } else if (status !== 200 && status !== 204) {
                const _responseText = response.data;
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }
            return Promise.resolve<ShoppingCartDTO>(null as any);
        }

    byidentity(shoppingCartIdentity?: string | undefined, cancelToken?: CancelToken): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/api/shoppingcart/byidentity?";
        if (shoppingCartIdentity === null)
            throw new Error("The parameter 'shoppingCartIdentity' cannot be null.");
        else if (shoppingCartIdentity !== undefined)
            url_ += "shoppingCartIdentity=" + encodeURIComponent("" + shoppingCartIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processByidentity(_response);
        });
    }

    protected processByidentity(response: AxiosResponse): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShoppingCartDTO.fromJS(resultData200);
            return Promise.resolve<ShoppingCartDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartDTO>(null as any);
    }

    /**
     * @param shoppingCartIdentity (optional) 
     * @return OK
     */
    shoppingcartitemsbyidentity(shoppingCartIdentity?: string | undefined, cancelToken?: CancelToken): Promise<ShoppingCartInternalItemDTO[]> {
        let url_ = this.baseUrl + "/api/shoppingcart/shoppingcartitemsbyidentity?";
        if (shoppingCartIdentity === null)
            throw new Error("The parameter 'shoppingCartIdentity' cannot be null.");
        else if (shoppingCartIdentity !== undefined)
            url_ += "shoppingCartIdentity=" + encodeURIComponent("" + shoppingCartIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShoppingcartitemsbyidentity(_response);
        });
    }

    protected processShoppingcartitemsbyidentity(response: AxiosResponse): Promise<ShoppingCartInternalItemDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShoppingCartInternalItemDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShoppingCartInternalItemDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingCartInternalItemDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addshoppingcart(body?: ShoppingCartItemDTO[] | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/public/shoppingcart/addshoppingcart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddshoppingcart(_response);
        });
    }

    protected processAddshoppingcart(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}
export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

